import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button"; // Ensure Button.tsx is correctly implemented

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  border-radius: 3px;
  height:83vh;
`;

const Logo = styled.img`
  width: 120px; /* Adjust size */
  height: auto;
  margin-bottom: 10px; /* Spacing below the logo */
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align text and radio buttons to the left */
  text-align: left;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  color: #FF372F;
  text-align: center;
  width: 100%;
`;

const Label = styled.p`
  color: #FF372F;
  margin-bottom: 20px;
  font-weight:bold;
  padding-left:10px;
`;

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  cursor: pointer;
`;

const RadioButton = styled.div<{ selected: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid white;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.selected ? "white" : "transparent")};
`;

const OptionText = styled.span`
  color: white;
  font-size: 16px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const CalculatorSelection: React.FC = () => {
  const navigate = useNavigate();
  const [selectedCalculator, setSelectedCalculator] = useState<string>("fatigue");

  return (
    <Container>
      {/* Logo Added Above the Title */}
      <Logo src="/Health-Safety-Wellbeing.png" alt="Health, Safety & Wellbeing Logo" />

      <ContentWrapper>
        <Title>Health & Safety</Title>
        <Label>Please Select the Tool</Label>

        {/* Fatigue Risk Calculator */}
        <OptionContainer onClick={() => setSelectedCalculator("fatigue")}>
          <RadioButton selected={selectedCalculator === "fatigue"} />
          <OptionText>Fatigue Risk Calculator</OptionText>
        </OptionContainer>

        {/* Other Calculator
        <OptionContainer onClick={() => setSelectedCalculator("other")}>
          <RadioButton selected={selectedCalculator === "other"} />
          <OptionText>Other Tool</OptionText>
        </OptionContainer> */}

        {/* Proceed Button - Centered */}
        <ButtonContainer>
          <Button title="Proceed" onClick={() => navigate("/welcome")} />
        </ButtonContainer>
      </ContentWrapper>
    </Container>
  );
};

export default CalculatorSelection;
